export default __webpack_public_path__ + "static/media/KRuxULB.6a80a295.png";